<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <ul class="content">
                <draggable
                    :class="dataList.array != '1' ? 'mul-colums' : ''"
                    :group="{
                        name: 'name1',
                        put: false,
                        pull: false,
                    }"
                    force-fallback="true"
                    v-model="dataList.optionsList"
                    animation="300"
                    itemKey="value"
                    handle=".operation-drag"
                    ghostClass="option-ghost-class"
                >
                    <template #item="{ element, index }">
                        <li
                            class="content-item"
                            :style="{
                                paddingLeft: element.type != 'group' ? '32px' : '',
                            }"
                        >
                            <div class="placeholder-content">
                                <div v-if="element.type != 'group'" class="icon-box">
                                    <div class="icon"></div>
                                </div>
                                <!-- 输入框 -->
                                <rich-text-editor
                                    :class="element.other ? 'content-input content-input-other' : 'content-input'"
                                    v-model:valueData="element.label"
                                    @mouseenter="() => (element.buttonShowHover = true)"
                                    @mouseleave="() => (element.buttonShowHover = false)"
                                    @focus="() => (element.buttonShow = true)"
                                    @blur="() => (element.buttonShow = false)"
                                >
                                    <template #operation>
                                        <!-- 鼠标触摸展示的按钮 -->
                                        <div class="operation-box" v-show="element.buttonShowHover || element.buttonShow">
                                            <div class="operation-drag">
                                                <el-tooltip content="长按拖动" effect="customized" placement="top">
                                                    <svg-icon name="operationDrag" class="svg-icon" />
                                                </el-tooltip>
                                            </div>
                                            <div class="operation-group" v-if="element.type != 'group'" @click="groupOption(index)">
                                                <el-tooltip content="分组" effect="customized" placement="top">
                                                    <svg-icon name="operationVector" class="svg-icon" />
                                                </el-tooltip>
                                            </div>
                                            <div class="operation-delete" v-if="dataList.optionsList.length > 1" @click="deleteOption(index)">
                                                <el-tooltip content="删除" effect="customized" placement="top">
                                                    <svg-icon name="operationDelete" class="svg-icon" />
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </template>
                                </rich-text-editor>
                            </div>
                        </li>
                    </template>
                </draggable>
            </ul>
            <!-- 底部操作栏 -->
            <div class="footer-operation">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                    <!-- 添加左侧操作按钮 -->
                    <template #operation>
                        <div class="bottom-operation">
                            <div class="button1" @click="addSingleOption(false)"><svg-icon name="addOption" class="icon" />添加选项</div>
                            <div class="button1" @click="addSingleOption(true)"><svg-icon name="addOption" class="icon" />添加其他项</div>
                            <div class="button1" @click="openBatchDialog"><svg-icon name="batchEdit" class="icon" />批量编辑选项</div>
                        </div>
                    </template>
                </action-bar>
            </div>
            <batch-edit ref="batchEdit" :optionsList="dataList.optionsList" @confirmOption="confirmOption" />
        </div>
    </div>
</template>
<script setup name="kr-multiple-choice">
// js
import Draggable from "vuedraggable";
import { ref, watch, provide } from "vue";
// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import BatchEdit from "@/components/dialog/BatchEdit.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]); // 复制题目，删除题目, 数据改变, 单题预览;

const batchEdit = ref(null);
const titileInput = ref(null);
let liWidth = ref("");

watch(
    () => props.dataList,
    (curr, old) => {
        const array = props.dataList.array;
        const width = ["", "100%", "50%", "33%"];
        // 每列宽度
        liWidth.value = width[array];

        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);
provide("data", props.dataList);
defineExpose({ titileInput });

// 打开批量编辑选项弹框
function openBatchDialog() {
    batchEdit.value.dialogVisible = true;
    batchEdit.value.newOption = "";
}

function confirmOption(data) {
    props.dataList.optionsList = data;
}

// 删除当前选项
function deleteOption(index) {
    props.dataList.optionsList.splice(index, 1);
}
// 当前题型前添加分组
function groupOption(index) {
    // other 是其他选项 true和undefined
    let defaultHolder = "组";
    let obj = {
        label: defaultHolder,
        value: props.dataList.optionsList.length + 1,
        type: "group",
    };
    props.dataList.optionsList.splice(index, 0, obj);
}
// 添加单个选项
function addSingleOption(other) {
    // other 是其他选项 true和undefined
    let defaultHolder = other ? "其他" : `选项${props.dataList.optionsList.length + 1}`;
    let obj = {
        label: defaultHolder,
        value: props.dataList.optionsList.length + 1,
        other,
    };
    props.dataList.optionsList.push(obj);
}
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.mul-colums {
    display: flex;
    flex-wrap: wrap;
    .content-item {
        width: v-bind(liWidth);
    }
}
.content {
    width: calc(100% - 200px);
    margin-left: 0 !important;
    .content-item {
        // background-color: #fff;
        position: relative;
        margin-bottom: 6px;

        cursor: pointer;
        .icon-box {
            position: absolute;
            top: 50%;
            left: 9px;
            transform: translateY(-50%);
            .icon {
                width: 16px;
                height: 16px;
                border: 1px solid #ccc;
                border-radius: 2px;
                background-color: #fff;
            }
        }
        .content-input-other {
            :deep(.editor-content::after) {
                position: relative;
                top: 4px;
                content: "";
                display: inline-block;
                width: 92px;
                height: 19px;
                border: 1px solid rgba(235, 237, 243, 1);
                border-radius: 4px;
                background-color: #fff;
                margin-left: 10px;
            }
        }
        .content-input {
            width: calc(100% - 110px);
            color: rgba(112, 120, 134, 1) !important;
        }
        .operation-box {
            display: flex;
            align-items: center;
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(100%, -50%);
            color: #9aa1ad;
        }
        .left-drag-icon,
        .operation-delete,
        .operation-add,
        .operation-drag,
        .operation-group {
            width: 20px;
            height: 20px;
            margin-left: 15px;
            .svg-icon {
                width: 100%;
                height: 100%;
                &:hover {
                    color: rgb(34, 64, 195);
                }
            }
        }
        .operation-delete .svg-icon:hover {
            color: red;
        }
    }
}
</style>
